import React from "react";
import { NavLink } from "react-router-dom";

const NavButton = ({ redirectRoute, svgPath, title }) => {
  return (
    <NavLink
      to={redirectRoute}
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 bg-blue-200 border-l-2 border-blue-800 text-blue-800"
          : "flex items-center p-2 text-grey-800 rounded-lg border-blue-800"
      }
      // flex items-center p-2 text-grey-800 rounded-lg  hover:bg-blue-200 hover:rounded-none hover:border-l-2 border-blue-800 hover:text-blue-800
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{ __html: svgPath }}
      ></svg>
      <span className="ml-3">{title}</span>
    </NavLink>
  );
};

export default NavButton;
